/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import makeStyles from '@material-ui/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import { useUID } from 'react-uid';
import { array, bool, func, string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import ContactsIcon from '@material-ui/icons/Contacts';
import { useAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import FloraVerseRecipients from '../FloraVerse/FloraVerseRecipients';
const useStyles = (mobile, isDadJokeGPT, isFloraVerse) =>
    makeStyles(() => ({
        card: {
            color: `${isDadJokeGPT ? '#081E3F' : '#000000'} !important`,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: '15px 20px',
            margin: '24px 0',
            boxShadow: isDadJokeGPT ? `0px 0px 5px rgba(47, 47, 47, 0.25)` : 'none',
            borderRadius: '8px',
        },
        fieldSet: {
            border: 0,
            padding: 0,
            margin: 0,
            position: 'relative',
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        title: {
            textAlign: 'center',
            fontWeight: 700,
            fontSize: `${mobile ? '18px' : '20px'} !important`,
            lineHeight: '26px',
            marginBottom: '25px !important',
        },
        radio: {
            fontSize: '16px !important',
            padding: '8px 20px',
            borderRadius: '30px',
            backgroundColor: '#F5F5F5',
            minWidth: '75px',
            cursor: 'pointer',
            fontWeight: 400,
            lineHeight: '20px',
            textAlign: 'center',
        },
        active: {
            backgroundColor: `${isDadJokeGPT ? '#081E3F' : isFloraVerse ? '#117B91': '#F55858'}`,
            color: '#FFFFFF',
        },
        radioInput: {
            position: 'absolute !important',
            clip: 'rect(0,0,0,0)',
            pointerEvents: 'none',
        },
        cardContainer: {
            marginTop: '1rem',
            width: '100%',
        },
        input: {
            height: '50px',
            width: '100%',
            marginBottom: '16px',
            backgroundColor: '#F5F5F5',
            border: '1px solid #E9E9E9',
            borderRadius: '4px',
        },
        addressBookBtnAndTextContainer: {
            display: 'flex',
            marginTop: '1rem'
        },
        addressBookButton: {
            width: mobile ? '40px' : '200px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#F5F5F5',
            padding: '6px',
            border: '1px solid #F5F5F5',
            borderRadius: 2,
            cursor: 'pointer',
            fontWeight: 700,
            margin: '1rem',
            '&:focus': {
                outline: '1px solid #F5F5F5',
            },
        },
        addressBoxTextContainer: {
            display: 'relative',
            width: '100%',
            marginTop: '1rem'
        },
        characterLimitNote: {
            marginTop: '2rem',
            fontSize: '1rem'
        }
    }));

const CardWithButtons = ({ title, mobile, setIsDadJokeSelected, isDadJokeGPT, handleOptionChange, isAddressBookVisible, isFloraVerse, ...props }) => {
    const classesLayout = useStyles(mobile, isDadJokeGPT, isFloraVerse);
    const classes = classesLayout();
    const [currentOption, setCurrentOption] = useState('');
    const isAuthenticated = useSelector((state) => state?.member?.auth?.isAuthenticated);
    const {
        loginByRedirect,
    } = useAuth();
    const [otherOption, setOtherOption] = useState('');
    const [isRecipientListVisible, setIsRecipientListVisible] = useState(false);
    const formLabel = useUID();
    const handleFormChange = (e, other = false) => {
        const { value } = e.target;
        if (isDadJokeGPT) {
            if (title === 'Write a:' && value === 'Dad Joke') {
                setIsDadJokeSelected(true);
            } else if (title === 'Write a:' && value !== 'Dad Joke') {
                setIsDadJokeSelected(false);
            }
        }
        setCurrentOption(value);
        setOtherOption(other ? value : '');
        setIsRecipientListVisible(false);
        handleOptionChange(value);
    };
    const handleAddressButtonClick = async () => {
        if(isAuthenticated){
            setIsRecipientListVisible(true)
        }else{
            await loginByRedirect({
                redirect_uri: `${window.location.origin}/auth/callback`,
            }, {
                routeBack: '/account/floraverse',
            });
        }
    }
    return (
        <Paper className={classes.card}>
            <p className={classes.title}>{title}</p>
            <fieldset
                className={classes.fieldSet}
                aria-labelledby={`${formLabel}-radio-group`}
                name={`${formLabel}-controlled-radio-buttons-group`}
            >
                {props.options.map((val) => (
                    <label
                        className={`${classes.radio} ${currentOption === val && !otherOption ? classes.active : ''}`}
                        key={`button${useUID()}`}
                    >
                        {val}
                        <input
                            className={classes.radioInput}
                            type="radio"
                            aria-disabled={false}
                            name={`${formLabel}-controlled-radio-buttons-group`}
                            value={val}
                            onClick={(e) => handleFormChange(e)}
                        />
                    </label>
                ))}

            </fieldset>
            {isAddressBookVisible && (
                <>
                    {isRecipientListVisible ? (
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1rem' }}>
                            <FloraVerseRecipients
                                setIsRecipientListVisible={setIsRecipientListVisible}
                                setOtherOption={setOtherOption}
                                handleOptionChange={handleOptionChange}
                                
                            />
                        </div>
                    ) : (
                        <div className={classes.addressBookBtnAndTextContainer}>
                            <div
                                onClick={handleAddressButtonClick}
                                className={classes.addressBookButton}
                                role="button"
                                tabIndex={0}
                                aria-label="Open Address Book"
                            >
                                <ContactsIcon style={{ marginRight: '6px' }} />{mobile? '': 'Address Book' }
                            </div>
                            <div className={classes.addressBoxTextContainer}>
                                <TextField
                                    autoComplete="off"
                                    className={classes.input}
                                    value={otherOption}
                                    name="Other"
                                    placeholder={props.placeholder}
                                    onChange={(e) => handleFormChange(e, true)}
                                    inputProps={{ style: { fontSize: '16px', color: '#000' } }}
                                    InputProps={{
                                        style: {
                                            fontSize: '16px',
                                            height: '50px',
                                            width: '100%',
                                            padding: '0 14px',
                                        },
                                        disableUnderline: true,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}

            {props.characterLimitNote && <div className={classes.characterLimitNote}>{props.characterLimitNote}</div>}
            {!isAddressBookVisible && props.placeholder && (
                <div className={classes.cardContainer}>
                    <TextField
                        autoComplete="off"
                        className={classes.input}
                        value={otherOption}
                        name="Other"
                        placeholder={props.placeholder}
                        onChange={(e) => handleFormChange(e, true)}
                        inputProps={{ style: { fontSize: '16px', color: '#000' } }}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                height: '50px',
                                width: '100%',
                                padding: '0 14px',
                            },
                            disableUnderline: true,
                        }}
                    />
                </div>
            )}

        </Paper>
    );
};

CardWithButtons.defaultProps = {
    title: '',
    options: [],
    placeholder: '',
    isDadJokeGPT: false,
    isAddressBookVisible: false,
};

CardWithButtons.propTypes = {
    handleOptionChange: func.isRequired,
    title: string.isRequired,
    options: array.isRequired,
    placeholder: string,
    mobile: bool.isRequired,
    isDadJokeGPT: bool,
    setIsDadJokeSelected: func.isRequired,
    isAddressBookVisible: bool,
    characterLimitNote: string,
};

export default CardWithButtons;
